import { authRoleAccess } from 'auth/AuthRoleAccess'
import { lazy } from 'react'

const Reports = lazy(() => import('./Reports'))

const ReportsRoutes = [
    {
        path: '/reports',
        component: Reports,
        auth: authRoleAccess.reports,
    },
   
]

export default ReportsRoutes